module.exports = __webpack_public_path__ + "static/media/34.c54f2493.png";